import settings from './settings';
import { authHeader } from './authHeader';
import { authService } from './authService';


export function getTerminations(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };
    return fetch(`${settings.API_URL}terminations`, requestOptions).then(authService.handleResponse);
}


export function addTermination(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };
    return fetch(`${settings.API_URL}addtermination`, requestOptions).then(authService.handleResponse);
}

export function editTermination(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };
    return fetch(`${settings.API_URL}updatetermination/${data.id}`, requestOptions).then(authService.handleResponse);
}


export function getTermination(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(`${settings.API_URL}termination/${id}`, requestOptions).then(authService.handleResponse);
}
